import React, { useEffect, useState } from "react";
import { MdOutlineCancelPresentation } from "react-icons/md";

function TransactionIdModal({ setIsModalOpen, transactData }) {
  return (
    <>
      <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex justify-center items-center">
        <div className="modal-content flex flex-col justify-center h-fit w-[400px] bg-white p-6 rounded shadow-lg relative">
          {/* <button
            onClick={() => setIsModalOpen(false)}
            className="close absolute top-3 right-2 py-1 cursor-pointer px-4 text-orange-400 border border-orange-400 rounded-md"
          >
            x
          </button> */}
          <MdOutlineCancelPresentation
            onClick={() => setIsModalOpen(false)}
            className="text-orange-400 text-[25px] right-5 absolute top-3 cursor-pointer"
          />

          <div>
            <h3 className="border-b text-2xl text-black-shade text-center font-bold pb-4">
              Transaction Summary
            </h3>
            <p className="py-3 flex justify-between border-b">
              <span className="font-semibold">Transaction ID:</span>{" "}
              {transactData.id}
            </p>
            <p className="py-3 flex justify-between border-b">
              <span className="font-semibold">Exp Month:</span>{" "}
              {transactData.expMonth}
            </p>
            <p className="py-3 flex justify-between border-b">
              <span className="font-semibold">Exp Year:</span>{" "}
              {transactData.expYear}
            </p>
            <p className="py-3 flex justify-between border-b">
              <span className="font-semibold">Transaction Date:</span>{" "}
              {new Date(transactData.initiated).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
            <p className="py-3 flex justify-between border-b">
              <span className="font-semibold">Completion Date:</span>{" "}
              {new Date(transactData.completed).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
            <p className="py-3 flex justify-between border-b font-semibold">
              <span className="font-semibold">Transaction Amount:</span>
              {transactData.amount.toFixed(2)}
            </p>
            
            <p className="py-3 flex justify-between border-b">
              <span className="font-semibold">Status Description:</span>{" "}
              {transactData.statusDescription}
            </p>
            <p className="py-3 flex justify-between border-b">
              <span className="font-semibold">Status:</span>{" "}
              {transactData.status}
            </p>
            <p className="py-3 flex justify-between border-b">
              <span className="font-semibold">Approval Code:</span>{" "}
              {transactData.approvalCode}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default TransactionIdModal;
